<template>
  <div class="price-search">
    <van-search v-model="value" placeholder="请输入关键词搜索" @search="onSearch" :clearable="false">
      <template #left-icon>
        <img src="@/assets/imgs/搜索.png" alt="" style="display: none;">
      </template>
      <template #right-icon>
        <van-icon name="search" size="20px" @click="onSearch" />
      </template>
    </van-search>
  </div>
</template>

<script>
export default {
  name: "Search",
  data() {
    return {
      value: '',
    };
  },
  props: {
    keyName: String,
    searchStr: String,
  },
  watch:{
    searchStr(val){
      this.value = val
    }
  },
  computed: {},
  methods: {
    onFilter() {
      this.$emit("onFilter");
    },
    onSearch() {
      this.$emit("onSearch", this.value)
    },
    onCancel() {
     
    },
  }
};
</script>

<style lang="stylus" scoped>
.price-search {
  padding: 0 32px;
  margin: 0 0 30px;

  >>> .van-search {
    width: 100%;
    height: 72px;
    background: #FFFFFF;
    border-radius: 36px 36px 36px 36px;
  }

  >>> .van-search__content {
    background: transparent;
  }

  >>> .van-field__control {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 24px;
    color: #3f3f3f;
  }

  >>> .van-field__right-icon {
    img {
      width: 32px;
      height: 32px;
    }
  }
}
</style>
